
export const eventKeys = {
    loginSuccess: "loginSuccess",
    logout: "logout",
    usercreated: "usercreated",
    coursecreated: "coursecreated",
    courseid: "courseid"

}